<mat-form-field class="xp-search-field__form-field"
                appearance="outline"
                subscriptSizing="dynamic"
                [floatLabel]="floatLabel()">
	<mat-label *ngIf="label()">{{ label() }}</mat-label>
	<mat-icon matPrefix class="xp-search-field__icon">search</mat-icon>
	<input *ngIf="autocomplete()"
	       matInput
	       class="xp-search-field__input"
	       [type]="type()"
	       [matAutocomplete]="autocomplete()!"
	       [ngModel]="value()"
	       (ngModelChange)="onInput($event)"
	       [placeholder]="placeholder()"
	       [attr.aria-label]="ariaLabel()" />
	<input *ngIf="!autocomplete()"
	       matInput
	       class="xp-search-field__input"
	       [type]="type()"
	       [ngModel]="value()"
	       (ngModelChange)="onInput($event)"
	       [placeholder]="placeholder()"
	       [attr.aria-label]="ariaLabel()" />
	<button *ngIf="showClear() && value()"
	        mat-icon-button
	        matSuffix
	        type="button"
	        aria-label="Clear search"
	        (click)="clear.emit()">
		<mat-icon>close</mat-icon>
	</button>
</mat-form-field>
